    
      <header class="modal-header">

        <h2 class="modal-title">
            Termo de Saúde - (Leia com Atenção!)
        </h2>

        <span></span>
      </header>

      <main class="main__content__modal modal-body" #artigoSaude>
            
                <b>
                    DECLARAÇÃO DE INFORMAÇÃO, CIÊNCIA E AUTORIZAÇÃO DO BENEFICIÁRIO QUANTO AOS 
                    IMPACTOS DA ADESÃO AO PROGRAMA DE DEMISSÃO VOLUNTÁRIA – PDV 2023 NO PLANO DE 
                    SAÚDE PROSAÚDE II
                </b>            
        
            <p class="clausula">
                Serve a presente declaração de informação, ciência e autorização do beneficiário quanto aos 
                impactos da adesão ao Programa de Demissão Voluntária – PDV 2023, no âmbito da patrocinadora COPEL, 
                no plano de saúde <b>PROSAÚDE II</b>, para que o(a) beneficiário(a), expressamente, (i) informe sua adesão ao 
                PDV da PATROCINADORA, (ii) tome ciência de seus termos e das condições posteriores a que estará 
                submetido, perante a Entidade, no que se refere a sua manutenção ou não no plano de saúde <b>PROSAÚDE 
                II</b>, bem como para que, desde já, (iii) autorize as alterações cadastrais necessárias à efetivação da opção 
                de permanência ou exclusão após os 12 (doze) meses, nos termos abaixo transcritos.
            </p>        

            <p style="margin-top: 0.5rem; margin-bottom: 0.5rem;">
                Por meio do presente documento:
            </p>

            <section class="primeiro-paragrafo">

                <p class="clausula">
                    <b>Informo</b> que aderi ao Programa de Demissão Voluntária – PDV 2023 no âmbito da 
                    Patrocinadora COPEL e que, diante da concessão de manutenção do pagamento do subsídio mensal da 
                    parte do empregador, referente à mensalidade do plano de saúde, <b>tenho conhecimento</b> de que me foi 
                    assegurado a <b>permanência no PROSAÚDE II por 12 (doze) meses após o desligamento, com a 
                    manutenção do pagamento do subsídio mensal de 80%</b>, conforme descrito nos itens 4.2 e 10.2 da 
                    CIRCULAR 032/2023 da COPEL;
                </p>

                <p class="clausula">
                    <b>Tenho ciência</b> de que o prazo de 12 (doze) meses após o desligamento, estipulado pelo PDV
                    2023, começa a contar a partir da data do desligamento do empregado na Patrocinadora, sendo exigido
                    pela Fundação Copel a apresentação da Carteira de Trabalho e Previdência Social – CTPS com a respectiva
                    anotação de data de saída da COPEL para que seja possível dar início ao processo de manutenção do plano
                    de saúde nos moldes estabelecidos no PDV;
                </p>

                <p class="clausula">
                    <b>Tenho ciência</b> de que, durante o período de 12 (doze) meses concedido pelo Programa, a
                    responsabilidade de pagamento dos valores à título de mensalidade sem subsídio (20%) e respectivas
                    coparticipações é do próprio Beneficiário. O pagamento se dará por meio de boleto bancário emitido pela
                    Operadora ou, no caso dos aposentados, por desconto na folha de pagamento.
                </p>

                <p class="clausula">
                    <b>Tenho ciência</b> de que a adesão no programa em nada altera as consequências da
                    inadimplência, parcial ou total, que poderá levar a suspensão ou exclusão do plano de saúde do titular e
                    de seus dependentes, nos moldes regulados pela Agência Nacional de Saúde Suplementar – ANS;
                </p>

                <p class="clausula">
                    <b>Tenho ciência</b> de que ao final dos 12 (doze) meses de manutenção no plano de saúde, 
                    concedidos pelo PDV, estarei submetido apenas às regras da Fundação Copel de Previdência e Assistência 
                    Social no que se refere à possibilidade ou não de manter o plano de saúde e eventual subsídio da 
                    patrocinadora. 
                </p>

            </section>

            <section class="segundo-paragrafo">
                <p class="clausula">
                    <b>Informo</b> que fui orientado pela Fundação Copel de Previdência e Assistência Social e tenho 
                    ciência de que, <b>ao final dos 12 (doze) meses de manutenção no plano de saúde, concedidos pelo PDV</b>:
                </p>

                <p class="clausula">
                    As opções de continuidade no plano de saúde PROSAÚDE II são vinculadas a opção 
                    previdenciária tomada quando finalizado o período de 12 (doze) meses concedido pelo Programa;
                </p>

                <p class="clausula">
                    A opção por se tornar assistido, autopatrocinado ou vinculado, no âmbito da previdência 
                    privada fechada da Fundação Copel deverá ser tomada na data do desligamento do empregado na
                    Patrocinadora. A escolha interferirá na elegibilidade do empregado para manutenção do plano de saúde 
                    após o período garantido pelo Programa bem como na continuidade de recebimento de subsídio no 
                    pagamento da mensalidade do <b>PROSAÚDE II</b>; 
                </p>

                <p class="clausula">
                    Aos ex-empregados que preencham os requisitos de elegibilidade para se tornarem
                    participantes assistidos(aposentados) no plano de previdência na data de desligamento da Patrocinadora,
                    será garantido o recebimento de subsídio no pagamento da mensalidade do <b>PROSAÚDE II</b> na proporção 
                    de <b>50%</b> quando finalizado o período de 12 (doze) meses concedido pelo Programa;
                </p>

                <p class="clausula">
                    Aos ex-empregados que não preencham os requisitos de elegibilidade para se tornarem
                    participantes assistidos(aposentados) no plano de previdência na data de desligamento da Patrocinadora,
                    desde que possuam ditos requisitos até o final do período de 12 (doze) meses de manutenção do plano
                    de saúde, será assegurada a opção de se manterem como autopatrocinados ou vinculados e, ao final do
                    período garantido pelo Programa, optarem por se tornarem assistidos, situação na qual será garantido o
                    recebimento de subsídio no pagamento da mensalidade do <b>PROSAÚDE II</b> na proporção de <b>50%</b>;
                </p>

                <p class="clausula">
                    Aos ex-empregados que não preencham os requisitos de elegibilidade para se tornarem
                    participantes assistidos(aposentados) no plano de previdência na data de desligamento da Patrocinadora,
                    nem ao final do período de 12 (doze) meses de manutenção do plano de saúde, caberá somente a opção
                    de manter seu vínculo previdenciário com a Fundação Copel como autopatrocinado ou vinculado, sendo
                    que após o período garantido pelo Programa, sua manutenção no <b>PROSAÚDE II</b> será condicionada ao
                    pagamento de mensalidade <b>integral</b>;
                </p>

                <p class="clausula">
                    Aos ex-empregados que solicitarem o resgate da reserva de poupança ou portabilidade, ao 
                    final dos 12 (doze) meses de manutenção no plano de saúde concedidos pelo PDV, <b>não será assegurado</b>
                    o direito a permanência no <b>PROSAÚDE II</b>, sendo imediata a sua <b>exclusão</b>. Logo, quando finalizado o 
                    período concedido pelo Programa, a Fundação Copel <b>cancelará</b> o plano de saúde, servindo a presente 
                    declaração como autorização para tanto, sendo a única opção do beneficiário a portabilidade de carências 
                    para plano de saúde diverso, que deverá ser solicitada pelo titular do plano de saúde com um período 
                    mínimo de 30 (trinta) dias antes da data prevista para o cancelamento.
                </p>

            </section>

            <section class="terceiro-paragrafo">
                <p class="clausula">
                    <b>Autorizo</b>, desde logo, que a Fundação Copel realize as alterações cadastrais necessárias à 
                    efetivação da opção de permanência ou exclusão de meu plano de saúde, bem como dos subsídios 
                    correspondentes, após os 12 (doze) meses de manutenção no plano de saúde concedidos pelo PDV, 
                    inclusive quando se tratar de cancelamento em virtude da opção pelo resgate da reserva de poupança 
                    (conforme descrito no item 2.6).
                </p>
            </section>

            <div class="form-check form-check-inline col-12 py-3">
                <input class="form-check-input" type="checkbox" name="idCheckboxAcordoSaude" id="idCheckboxAcordoSaude" value="true" tabindex="-1" [(ngModel)]="aceite">
                <label class="form-check-label label-form" for="idCheckboxAcordoSaude">Concordo</label>
              </div>
      </main>

      <footer class="footer-body">
        <button class="btn btn-primary mt-2 col-xl-2 col-lg-3 col-md-4 col-sm-12" [disabled]="!aceite" (click)="salvar()">          
          <div class="spinner-border" role="status"[@fadeInOut]>
            <span>Concordo</span>
          </div>
        </button>
      </footer>